module.exports = __webpack_public_path__ + "static/media/web-application-security.d8db330c.png";